<template>
	<div class="fasearch">
		<div class="contents">
			<div class="inputsearch">
				<el-input v-model="searchParams.queryInfo" clearable @clear="handleSearch" class="input-with-select" placeholder="海量资源 等你发现" @keyup.enter.native="handleSearch">
					<el-select slot="prepend" v-model="searchParams.itype" placeholder="全部">
						<el-option v-for="item in catOpt" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-input>
			</div>
			<div class="searchbtn pointer" @click="handleSearch"><img alt="" src="@/assets/images/searchbanner/search.png" style="width: 21px; margin-right: 10px" /> 检索</div>
		</div>
		<!--		<div class="keys">-->
		<!--			<div class="ktitle">热词：</div>-->
		<!--			<div class="tags">-->
		<!--				<div v-for="(tag, index) in keysGroup" :key="index" :class="'tagbg ' + tag.classval" @click="setKeyword2(tag.label)">{{ tag.label }}</div>-->
		<!--			</div>-->
		<!--		</div>-->
	</div>
</template>

<script>

	export default {
		inject: ['updateGrandData'], // 注入祖父组件提供的方法
		data() {
			return {
				searchParams: {
					queryInfo: '',
					itype: 0
				},
				auto: false,
				catOpt: [
					{
						id: 0,
						name: '标题'
					},
					{
						id: 1,
						name: '全文'
					}
				],
				keysGroup: [
					{
						classval: 'tagblue',
						label: '安全法'
					},
					{
						classval: 'tagred',
						label: '法规'
					},
					{
						classval: 'taggreen',
						label: '培训'
					},
					{
						classval: 'tagpurple',
						label: '标准规范'
					},
					{
						classval: 'tagblue',
						label: '管理系统'
					},
					{
						classval: 'tagred',
						label: '技术规程'
					}
				]
			};
		},
		components: {},
		methods: {
			getTypelist() {
				booktypelist().then(res => {
					this.catOpt = res.data;
				});
			},

			loadHotWords() {
				getHotWords().then(rlt => {
					this.keysGroup = [];
					let ccls = ['tagblue', 'tagred', 'taggreen', 'tagpurple', 'tagblue', 'tagred'];

					rlt.data.forEach((item, index) => {
						let info = {};
						info.id = item.id.trim();
						info.label = item.lable.trim();
						info.classval = ccls[index] || 'tagblue';

						this.keysGroup.push(info);
					});
				});
			},

			handleSearch() {
				// 将多个参数封装为对象
				this.updateGrandData(this.searchParams);
			},

			setKeyword2(kw) {
				this.setKeyword(kw);
				this.handleSearch();
			},

			setKeyword(kw) {
				this.fastkeys = kw;
			}
		},
		created() {
			// this.getTypelist();
			// this.loadHotWords();
			this.auto = false;
			if (this.$route.query.kw) {
				this.setKeyword(this.$route.query.kw);
				this.auto = true;
			}
			if (this.$route.query.type) {
				this.catval = this.$route.query.type;
				this.auto = true;
			}
		},

		mounted() {
			if (this.auto) {
				setTimeout(() => {
					this.handleSearch();
				}, 1000);
			}
		}
	};
</script>

<style lang="less" scoped>
	.fasearch {
		.contents {
			// width: 80%;
			border-radius: 7px 7px 7px 7px;
			background-color: #ffffff;
			display: flex;
			justify-content: start; /* 水平居中 */
			align-items: center;
			.inputsearch {
				width: 90%;
				height: 50px;
			}
		}
		.keys {
			margin-top: 18px;
			.ktitle {
				font-weight: 400;
				font-size: 12px;
				color: #888888;
			}
			display: flex;
			justify-content: start; /* 水平居中 */
			align-items: center;

			.tags {
				cursor: pointer;
			}
		}
		/deep/.el-input-group__prepend .el-select {
			width: 185px;
		}
		/deep/.el-input__inner {
			height: 50px;
			line-height: 50px;
			border: 0;
			border-radius: 0;
		}
		/deep/.el-input-group__prepend div.el-select .el-input__inner,
		.el-input-group__prepend div.el-select:hover .el-input__inner {
			background-color: #ffffff;
			border: 0;
		}
		/deep/.el-input-group__prepend {
			border: 0;
		}
		/deep/.el-input-group__prepend {
			color: #333333;
		}
		/deep/.input-with-select .el-input-group__prepend {
			background-color: #fff;
		}
	}
</style>
